import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
`;

export const StatusItem = styled.div<{ $status: string; $round?: boolean }>`
	font-size: 12px;
	font-weight: 500;
	background-color: ${({ $status, theme }) =>
		$status === 'send'
			? theme.colors.tag.bgYellow
			: $status === 'failed'
				? theme.colors.tag.bgRed
				: $status === 'pending' || $status === 'sent'
					? theme.colors.tag.bgBlue
					: theme.colors.tag.bgGreen};
	color: ${({ $status, theme }) =>
		$status === 'send'
			? theme.colors.tag.textYellow
			: $status === 'failed'
				? theme.colors.tag.textRed
				: $status === 'pending' || $status === 'sent'
					? theme.colors.tag.textBlue
					: theme.colors.tag.textGreen};
	border-radius: ${props => (props.$round ? '100px' : '4px')};
	display: inline-flex;
	height: 36px;
	padding: 4px 6px;
	align-items: center;
	justify-content: center;
	position: relative;

	img {
		cursor: pointer;
	}
`;

export const InfoIconWrapper = styled.div`
	cursor: pointer;

	svg {
		width: 16px;
		height: 16px;
		fill: ${({ theme }) => theme.colors.icon.chevron};
	}
`;

export const Error = styled.div`
	background-color: unset;
	height: unset;
	padding: 0;
	left: calc(100% + 8px);
	position: absolute;
	width: unset;
`;

export const Info = styled.div<{ $isVisible: boolean }>`
	background-color: ${({ theme }) => theme.colors.background.snackbar};
	border-radius: 8px;
	bottom: calc(100% + 21px);
	display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
	height: unset;
	left: 50%;
	padding: 12px;
	transform: translateX(-50%);
	width: 334px;
	position: absolute;
	z-index: 10;

	a {
		color: ${({ theme }) => theme.colors.text.link};
	}
`;

export const InfoTitle = styled.div`
	@include subtitle6m;
	color: ${({ theme }) => theme.colors.text.title};
	background-color: unset;
	display: block;
	height: unset;
	padding: 0;
	position: relative;
`;

export const InfoText = styled.div`
	background-color: unset;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 0;
	color: ${({ theme }) => theme.colors.text.body};
	display: block;
	font-size: 12px;
	font-weight: 400;
	height: unset;
	margin-top: 8px;
	padding: 0;
	padding-bottom: 8px;
	position: relative;
`;

export const Carret = styled.div`
	background-color: unset;
	border: 0;
	padding: 0;
	left: 50%;
	position: absolute;
	transform: translateX(-50%);
	top: 100%;

	svg {
		fill: ${({ theme }) => theme.colors.background.snackbar};
	}
`;
